import { render, staticRenderFns } from "./comp_Home-BigImage.vue?vue&type=template&id=4251abed&"
import script from "./comp_Home-BigImage.vue?vue&type=script&lang=js&"
export * from "./comp_Home-BigImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports